import React from "react";
import "./TopInstructorsSection.css";

const instructors = [
  {
    id: 1,
    name: "Gaurav Gupta",
    role: "ML & Agentic Expert",
    rating: "4.9",
    students: "40K+",
    courses: "18",
    image: "/Image/Instructors/Gaurav Gupta.jpg",
    linkedin: "https://www.linkedin.com/in/gauravright85/",
  },
  {
    id: 2,
    name: "Anmol Goel",
    role: "Python & AI Expert",
    rating: "4.8",
    students: "35K+",
    courses: "10",
    image: "/Image/Instructors/Anmol Goel.jpg",
    linkedin: "https://www.linkedin.com/in/-anmolgoel/",
  },
  {
    id: 3,
    name: "Somnath Mitra",
    role: "AI & ML Expert",
    rating: "4.9",
    students: "28K+",
    courses: "12",
    image: "/Image/Instructors/Somnath Mitra.jpg",
    linkedin: "https://www.linkedin.com/in/somnathmitra1/",
  },
  {
    id: 4,
    name: "Shalabh Kumar",
    role: "Applied Scientist",
    rating: "4.7",
    students: "22K+",
    courses: "11",
    image: "/Image/Instructors/Shalabh Kumar.jpg",
    linkedin: "https://www.linkedin.com/in/shalabh-kumar/",
  },
];


export default function TopInstructorsSection() {
  return (
    <section className="top-instructors">
      <header className="top-instructors-header">
        <h2>
          Meet our <span className="pink">Top</span>{" "}
          <span className="orange">Instructors</span>
        </h2>
        <p>Learn from industry experts with proven track records</p>
      </header>

      <div className="instructors-row">
        {instructors.map((inst) => (
          <article
            className="instructor-card"
            key={inst.id}
            onClick={() => window.open(inst.linkedin, "_blank")}
            role="button"
            tabIndex={0}
          >
            <div className="avatar-wrap">
              <img src={inst.image} alt={inst.name} />
              <div className="rating-pill">
                <span>★</span> {inst.rating}
              </div>
            </div>

            <h3>{inst.name}</h3>
            <p className="role">{inst.role}</p>

            <div className="stats-card">
              <div>
                <strong>{inst.students}</strong>
                <span>Students</span>
              </div>
              <div>
                <strong>{inst.courses}</strong>
                <span>Courses</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
